module.exports = () => context => {
  const { result } = context;

  if (Array.isArray(result.data)) {
    context.result.data = context.result.data.map(charge => ({
      ...charge,
      amount: +charge.amount
    }));

    return context;
  }

  context.result = {
    ...result,
    amount: +result.amount
  };

  return context;
};
